<template>
<div class="input-group input-group-outline mb-3" 
v-bind:class="{ 'focused is-focused': focused, 'is-filled': value }">
    <label class="form-label">{{label}}</label>
    <input
    
        :type="isTest ? 'text' : 'password'"
        :value="value"
        :class="'form-control ' + c_css"
        @input="$emit('input',$event.target.value)"
        @focus="focused=!focused"
        @blur="focused=!focused"
    />
    <span class="btn-pwd active" @click="isTest=!isTest">
        <template v-if="isTest">
            <eye-icon size="1x"></eye-icon>
        </template>
        <template v-else>
            <eye-off-icon size="1x"></eye-off-icon>
        </template>
        
    </span>
</div>
</template>
<script>
import { EyeIcon, EyeOffIcon } from 'vue-feather-icons'
export default{
    components:{
        EyeIcon,
        EyeOffIcon
    },
  data:()=>({
    focused:  false,
    isTest: false
  }),
  props: {
    value : { type: String , required: false, default: ''},
    label: { type: String , required: false, default: ''},
    placeholder: { type: String, required: false, default: ''},
    c_css: { type: String, required: false, default: ''}
  },
}
</script>
<style scoped>
.btn-pwd{
    position: absolute;
    float: left;
    top: 0px;
    bottom:0px;
    right: 0px;
    width:50px;
    color:#d2d6da;
    cursor: pointer;
    line-height: 40px;
    text-align: center;
    z-index: 9999;
}
</style>